export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img02.58f20244.jpg";